import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'

import { useCurrentModal } from '../../../../../components/modals/ModalsContext'
import {
  useOpenEditLinktreeItemsModal,
  useOpenEditLinktreeModal
} from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveLinkTree } from '../_request/removeLinkTree'

export const useLinkTreeActions = item => {
  const { t } = useTranslation(['listLinkTrees', 'common'])
  const data = useCurrentModal()
  const openEditItemsModal = useOpenEditLinktreeItemsModal()
  const openEditModal = useOpenEditLinktreeModal()

  const [deleteItems, { loading }] = useRemoveLinkTree()

  const singleOptions = [
    {
      value: t('listLinkTrees:editLinks'),
      icon: 'BsListStars',
      onClick: () => openEditItemsModal(item)
    },

    {
      value: t('listLinkTrees:editSettings'),
      icon: 'BsPencil',
      onClick: () => openEditModal({ ...data, id: item.id })
    },

    {
      value: t('common:remove'),
      color: COLORS.red,
      icon: 'BsTrash',
      onClick: () => deleteItems([item.id])
    }
  ]

  return [singleOptions, loading]
}
